export default __webpack_public_path__ + "static/home_hero-b177a01320fde4e562023aa6d371ef29.png";